import type { CityConfig } from "../city-template/types";

export const mountainViewConfig: CityConfig = {
  city: "Mountain View",
  state: "California",
  stateAbbr: "CA",
  slug: "mountain-view",
  route: "/cities/mountain-view",
  title: "Emergency Passport Mountain View, CA | Expedited & Fast Renewal Services",
  metaDescription: "Emergency passport and expedited passport services in Mountain View, CA — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Silicon Valley and Santa Clara County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Mountain View, CA",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Mountain View and Silicon Valley travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Mountain%20View%20California%20at%20golden%20hour%20with%20modern%20Google%20campus%20buildings%20and%20Shoreline%20Lake%20visible%2C%20Silicon%20Valley%20suburban%20tech%20corridor%20with%20modern%20glass%20architecture%20and%20green%20tree-lined%20streets%2C%20warm%20sunset%20light%20casting%20long%20shadows%2C%20professional%20aerial%20photography%20style%2C%20clean%20modern%20tech%20campus%20environment%2C%20no%20visible%20text%20or%20people%2C%20warm%20amber%20and%20green%20tones&width=1800&height=700&seq=mv-hero-001&orientation=landscape",
  heroImageAlt: "Mountain View California skyline at golden hour with Silicon Valley tech campus and Shoreline Lake",
  geoPosition: "37.3861;-122.0839",
  geoPlacename: "Mountain View, California",
  regionalAgency: {
    name: "San Francisco Passport Agency",
    address: "450 Golden Gate Ave, San Francisco, CA 94102",
    distance: "Located in San Francisco — approximately 45–60 minutes from Mountain View via US-101",
  },
  nearbyCitiesZips: [
    { name: "Mountain View", zips: "94035, 94039, 94040, 94041, 94042, 94043" },
    { name: "Sunnyvale", zips: "94085–94089" },
    { name: "Palo Alto", zips: "94301–94306" },
    { name: "Los Altos", zips: "94022, 94024" },
    { name: "Cupertino", zips: "95014, 95015" },
    { name: "Saratoga", zips: "95070, 95071" },
    { name: "Menlo Park", zips: "94025, 94026" },
    { name: "Redwood City", zips: "94061–94065" },
    { name: "San Jose", zips: "95110, 95111, 95112, 95113, 95116, 95117, 95118, 95119, 95120, 95121, 95122, 95123, 95124, 95125, 95126, 95127, 95128, 95129, 95130, 95131, 95132, 95133, 95134, 95135, 95136, 95138, 95139, 95140, 95141, 95148, 95150, 95151, 95152, 95153, 95154, 95155, 95156, 95157, 95158, 95159, 95160, 95161, 95164, 95170, 95172, 95173, 95190, 95191, 95192, 95193, 95194, 95196" },
    { name: "Santa Clara", zips: "95050–95056" },
    { name: "Milpitas", zips: "95035, 95036" },
    { name: "Campbell", zips: "95008, 95009, 95011" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Silicon Valley departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "San Jose", route: "/cities/san-jose" },
    { name: "San Francisco", route: "/cities/san-francisco" },
    { name: "Santa Clara", route: "/cities/santa-clara" },
    { name: "Sunnyvale", route: "/cities/sunnyvale" },
    { name: "Palo Alto", route: "/cities/san-jose" },
    { name: "Berkeley", route: "/cities/berkeley" },
    { name: "Oakland", route: "/cities/oakland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Mountain View remotely via secure courier. We do not have a walk-in office in Mountain View — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Silicon Valley travelers.",
  fpcOfficeAddress: "400 S El Camino Real, San Mateo, CA 94402",
  fpcOfficeDistance: "Serving all of Santa Clara County",
  serviceAreaIntro: "From the Google campus to Shoreline Amphitheatre, from the Castro Street corridor to North Bayshore — Fast Passport Center serves the entire Mountain View community. We regularly help travelers from Palo Alto, Sunnyvale, Los Altos, and Cupertino get their passports fast.",
  nearbyCitiesIntro: "We serve all Mountain View neighborhoods and nearby Silicon Valley cities including Palo Alto, Sunnyvale, Los Altos, Menlo Park, Cupertino, and Saratoga. If you are in Santa Clara County or the South Bay, we have you covered.",
  howItWorksIntro: "Most Mountain View travelers complete everything online and ship documents overnight. No need to drive to San Francisco or wait in line at the regional agency.",
  mistakesIntro: "With SFO and SJC serving as the Bay Area's primary international airports, Mountain View travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Mountain View and Silicon Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Mountain View? Here are the most common ones we hear from Silicon Valley travelers.",
  statePageRoute: "/states/california",
  statePageName: "California",
  dmvWebsite: "https://www.dmv.ca.gov",
  dmvLabel: "California DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Silicon Valley international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "James L.",
      location: "Mountain View, CA",
      rating: 5,
      text: "My business trip to Singapore was in 2 days and my passport expired. Fast Passport Center got me a new one in 30 hours. Absolutely saved my deal.",
      service: "Emergency Passport",
    },
    {
      name: "Priya M.",
      location: "Sunnyvale, CA",
      rating: 5,
      text: "Needed to renew for a family trip to India. The process was smooth, they reviewed my documents, and I had my passport in 4 days. Highly recommend.",
      service: "Passport Renewal",
    },
    {
      name: "David K.",
      location: "Palo Alto, CA",
      rating: 5,
      text: "Lost my passport a week before my honeymoon to Greece. They walked me through the DS-64 process and got me a replacement in 48 hours. Incredible.",
      service: "Lost Passport",
    },
    {
      name: "Elena R.",
      location: "Los Altos, CA",
      rating: 5,
      text: "As a frequent international business traveler in tech, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional and reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "mv-1",
      name: "Mountain View Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "680 N Rengstorff Ave",
      city: "Mountain View",
      state: "CA",
      zip: "94043",
      phone: "(650) 961-0644",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Mountain View",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Acceptance hours are limited. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "mv-2",
      name: "Sunnyvale Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1298 W El Camino Real",
      city: "Sunnyvale",
      state: "CA",
      zip: "94087",
      phone: "(408) 735-6086",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "3.2 miles from downtown Sunnyvale",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Busy location — book appointments 2+ weeks in advance. Limited weekend hours.",
      icon: "ri-mail-line",
    },
    {
      id: "mv-3",
      name: "Palo Alto Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "390 Waverley St",
      city: "Palo Alto",
      state: "CA",
      zip: "94301",
      phone: "(650) 329-1271",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Stanford University",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular location for Peninsula residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "mv-4",
      name: "Cupertino Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "21701 Stevens Creek Blvd",
      city: "Cupertino",
      state: "CA",
      zip: "95014",
      phone: "(408) 996-4418",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.8 miles from Apple Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for South Bay residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "mv-5",
      name: "Redwood City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1300 Veterans Blvd",
      city: "Redwood City",
      state: "CA",
      zip: "94063",
      phone: "(650) 368-7271",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.0 miles from downtown Redwood City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Peninsula residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "mv-6",
      name: "Santa Clara County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "70 W Hedding St",
      city: "San Jose",
      state: "CA",
      zip: "95110",
      phone: "(408) 299-5688",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "12 miles from Mountain View",
      website: "https://www.sccassessor.org/",
      websiteLabel: "Santa Clara County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — San Francisco", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Bay Area photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at South Bay acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Silicon Valley applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the San Francisco regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Silicon Valley families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Mountain View travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Mountain View." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Mountain View address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Mountain View before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Mountain View for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most Silicon Valley travelers." },
    { q: "How fast can I renew my passport in Mountain View?", a: "Fast Passport Center offers fast passport renewal in Mountain View in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my Asia trip?", a: "If your passport expires before your Asia trip, contact Fast Passport Center immediately. We can expedite your passport renewal in Mountain View in 24–48 hours so you don't miss your flights." },
    { q: "Can I get a same-day passport appointment near Mountain View?", a: "Same-day passport appointments are only available at the SF Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Mountain View residents." },
    { q: "Can I expedite a child passport in Mountain View?", a: "Yes. Fast Passport Center expedites child passports in Mountain View for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Mountain View with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    {
      q: "How fast can I get a passport in Mountain View?",
      a: "With Fast Passport Center's emergency courier service, Mountain View travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays.",
    },
    {
      q: "Do I need to visit the San Francisco Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "Where are the closest passport acceptance facilities in Mountain View?",
      a: "Popular options include the Mountain View Main Post Office (94043), Sunnyvale Post Office (94087), Palo Alto Post Office (94301), and Cupertino Post Office (95014). All require appointments. We help you find the most convenient location and schedule your visit.",
    },
    {
      q: "Can I get a same-day passport in Mountain View?",
      a: "Same-day passports are only available at the San Francisco Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option.",
    },
    {
      q: "What if I live in the South Bay or on the Peninsula?",
      a: "We serve all of Silicon Valley including Cupertino, Sunnyvale, Palo Alto, Los Altos, Menlo Park, Redwood City, and Saratoga. Our overnight shipping labels work from any UPS location, so your location within the Bay Area doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Mountain View?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline.",
    },
    {
      q: "Do you help with passport photos in Mountain View?",
      a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Mountain View and Sunnyvale offer passport photo services. We review your photos before submission to ensure they meet State Department standards.",
    },
    {
      q: "What documents do I need for a first-time passport in Mountain View?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Mountain View?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Silicon Valley families through the entire process and help schedule acceptance clerk appointments.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Mountain View", address: "2100 W El Camino Real, Mountain View, CA 94040", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Sunnyvale", address: "1155 W El Camino Real, Sunnyvale, CA 94087", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Palo Alto", address: "425 University Ave, Palo Alto, CA 94301", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "UPS Store — Cupertino", address: "10625 S Foothill Blvd, Cupertino, CA 95014", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — San Jose", address: "4055 Evergreen Village Square, San Jose, CA 95135", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Los Altos", address: "4546 El Camino Real, Los Altos, CA 94022", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Postal Annex — Menlo Park", address: "1010 El Camino Real, Menlo Park, CA 94025", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM" },
    { name: "Costco — Redwood City", address: "1600 El Camino Real, Redwood City, CA 94063", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "DMV — Mountain View",
      address: "505 W El Camino Real, Mountain View, CA 94040",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "DMV — San Jose",
      address: "2222 Senter Rd, San Jose, CA 95112",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Passport-ready photo services available. Online appointment booking.",
      featured: false,
    },
    {
      name: "DMV — Redwood City",
      address: "300 Brewster Ave, Redwood City, CA 94063",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "DMV — San Jose Capitol Express",
      address: "3230 Senter Rd, San Jose, CA 95111",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Express services for Santa Clara County residents. Appointment required.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "SJC",
      name: "San Jose International Airport",
      distance: "10 miles from Mountain View",
      address: "1701 Airport Blvd, San Jose, CA 95110",
      note: "The closest international airport to Mountain View. International flights to Mexico, Canada, Europe, and Asia.",
      flightUrl: "https://www.flysanjose.com/",
      flightLabel: "San Jose Airport",
      featured: true,
    },
    {
      code: "SFO",
      name: "San Francisco International Airport",
      distance: "25 miles from Mountain View",
      address: "San Francisco, CA 94128",
      note: "Major international hub for long-haul flights to Asia, Europe, and South America. Accessible via US-101.",
      flightUrl: "https://www.flysfo.com/",
      flightLabel: "SFO Flight Info",
      featured: false,
    },
    {
      code: "OAK",
      name: "Oakland International Airport",
      distance: "30 miles from Mountain View",
      address: "1 Airport Dr, Oakland, CA 94621",
      note: "Convenient for domestic flights and some international connections. Less crowded than SFO.",
      flightUrl: "https://www.oaklandairport.com/",
      flightLabel: "Oakland Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: "California Dept. of Public Health (Vital Records)",
      description: "State-issued birth and death certificates for all California counties",
      url: "https://www.cdph.ca.gov/Programs/CHSI/Pages/Vital-Records.aspx",
    },
    {
      label: "Santa Clara County Clerk-Recorder (Birth, Death, Marriage Records)",
      description: "Birth certificates, death certificates, and marriage records for Santa Clara County",
      url: "https://www.sccassessor.org/",
    },
    {
      label: "Santa Clara County Superior Court (Divorce Records)",
      description: "Divorce decrees and court records for Santa Clara County",
      url: "https://www.scscourt.org/",
    },
  ],
};